
import { getAccountingList, addCashRequirement, addReimbursement, uploadCashRequirement,
  updateCashRequirement, uploadReimbursement, getReimbursement, approvalReimbursement,
  emptyAccounting, updateReimbursement, deleteAccounting, getRunningAccountList,
  getAdminUsers, addRunningAccount, updateRunningAccount, getRedDot, emptyRedDot } from '@/api/accounting'

const accounting = {
  state: {
    total: 0,
    rows: [],
    redDot: [],
    row: {},
    datas: {},
    amount: {}
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_DATAS: (state, datas) => {
      state.datas = datas
    },
    SET_AMOUNT: (state, amount) => {
      state.amount = amount
    },
    SET_RED_DOT: (state, redDot) => {
      state.redDot = redDot
    }
  },
  actions: {
    // 查询报销请款主页面信息
    GetAccountingList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAccountingList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_AMOUNT', response.Data.Amount)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加请款信息
    AddCashRequirement({ commit }, params) {
      return new Promise((resolve, reject) => {
        addCashRequirement(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改请款信息
    UpdateCashRequirement({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCashRequirement(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddReimbursement({ commit }, params) {
      return new Promise((resolve, reject) => {
        addReimbursement(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 上传文件
    UploadCashRequirement({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadCashRequirement(params).then((response) => {
          commit('SET_DATAS', response.Data.Datas)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 上传文件
    UploadReimbursement({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadReimbursement(params).then((response) => {
          commit('SET_DATAS', response.Data.Datas)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetReimbursement({ commit }, params) {
      return new Promise((resolve, reject) => {
        getReimbursement(params).then(response => {
          commit('SET_ROW', response.Data.Data)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ApprovalReimbursement({ commit }, params) {
      return new Promise((resolve, reject) => {
        approvalReimbursement(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 清空小红点
    EmptyAccounting({ commit }, params) {
      return new Promise((resolve, reject) => {
        emptyAccounting(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateReimbursement({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateReimbursement(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeleteAccounting({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteAccounting(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // -------------------------------流水账------------------------------------
    // 查询报销请款主页面信息
    GetRunningAccountList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getRunningAccountList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询可下拉申报人
    GetAdminUsers({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAdminUsers(params).then(response => {
          commit('SET_BUY_SELLER', response.Data.AdminNameSelect)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 新增流水账
    AddRunningAccount({ commit }, params) {
      return new Promise((resolve, reject) => {
        addRunningAccount(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改流水账
    UpdateRunningAccount({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateRunningAccount(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询小红点相关
    GetRedDot({ commit }, params) {
      return new Promise((resolve, reject) => {
        getRedDot(params).then(response => {
          commit('SET_RED_DOT', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 清空小红点相关
    EmptyRedDot({ commit }, params) {
      return new Promise((resolve, reject) => {
        emptyRedDot(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default accounting



// WEBPACK FOOTER //
// ./src/store/modules/accounting.js